import { render, staticRenderFns } from "./ErrorInfo.vue?vue&type=template&id=16706552&scoped=true&"
import script from "./ErrorInfo.vue?vue&type=script&lang=js&"
export * from "./ErrorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16706552",
  null
  
)

export default component.exports